'use client';

import { useCallback } from 'react';

import { Tooltip } from '../../index';

import {
  FormHelperTextHelperText,
  FormHelperTextHelperTooltipIcon,
  FormHelperTextLabel,
  LabelStyled,
} from './styled';
import { FormHelperTextProps } from './types';

export const FormHelperText = (props: FormHelperTextProps) => {
  const { type, children, tooltipText, ...rest } = props;

  const renderTypography = useCallback(
    (variant: 'label2' | 'label3') => {
      return (
        <LabelStyled variant={variant} color="inherit">
          {children}
          {!!tooltipText && <FormHelperTextHelperTooltipIcon />}
        </LabelStyled>
      );
    },
    [children, tooltipText],
  );

  const renderHelper = useCallback(
    (variant: 'label2' | 'label3') => {
      if (!tooltipText) {
        return renderTypography(variant);
      }

      return <Tooltip title={tooltipText}>{renderTypography(variant)}</Tooltip>;
    },
    [renderTypography, tooltipText],
  );

  if (type === 'label') {
    return (
      <FormHelperTextLabel variant="outlined" {...rest}>
        {renderHelper('label2')}
      </FormHelperTextLabel>
    );
  }

  return (
    <FormHelperTextHelperText variant="outlined" {...rest}>
      {renderHelper('label3')}
    </FormHelperTextHelperText>
  );
};
